import axios from "axios";
import { attachAuthInterceptor } from "./authInterceptor";

/**
 * Agent/AI endpoints (/ai/*) are served same-origin: the vite dev proxy and
 * the CDN route them to ai.{stage}, and no committed .env sets
 * VITE_AI_API_BASE_URL. Hence the relative baseURL — deliberately NOT
 * env.api.ai.
 */
const aiClient = axios.create({
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(aiClient);

export default aiClient;
